import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { IDropdown, IDropdownItem } from 'codex-lib';

type LangItem = IDropdownItem & {
  nomeDoItem: string;
  codigo: string;
};

@Component({
  selector: 'app-dropdown-language',
  templateUrl: './dropdown-language.component.html',
  styleUrls: ['./dropdown-language.component.scss'],
})
export class DropdownLanguageComponent implements OnInit {
  currLang = '';
  langs: string[] = [];

  langDropdown: IDropdown;
  selectedLang: LangItem | null = null;
  private items: LangItem[] = [];

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.currLang = this.translate.currentLang;
    this.langs = this.translate.langs;

    this.items = (this.langs || []).map(l => ({
      codigo: l,
      nomeDoItem: this.translate.instant(l),
    })) as LangItem[];

    this.selectedLang = this.items.find(i => i.codigo === this.currLang) ?? null;

    this.rebuildDropdown();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currLang = event.lang;

      this.items = (this.langs || []).map(l => ({
        codigo: l,
        nomeDoItem: this.translate.instant(l),
      })) as LangItem[];

      this.selectedLang = this.items.find(i => i.codigo === this.currLang) ?? null;

      this.rebuildDropdown();
    });
  }

  private rebuildDropdown(): void {
    const placeholder =
      this.selectedLang?.nomeDoItem
      ?? this.translate.instant(this.currLang || 'pt');

    this.langDropdown = {
      items: this.items as IDropdownItem[],
      displayText: 'nomeDoItem',
      placeholder,
      showSearch: false,
      clearSelectionItem: false,
    };
  }

  onSelectedChanged(item: IDropdownItem | null): void {
    const lang = item as LangItem | null;
    if (!lang || !lang.codigo || lang.codigo === this.currLang) return;

    this.translate.use(lang.codigo).subscribe(() => {
      this.currLang = lang.codigo;

      this.selectedLang = this.items.find(i => i.codigo === this.currLang) ?? null;
      this.rebuildDropdown();
    });
  }
}